import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  orderCancelAndRefundUsingMultipleVoucherWithCC,
  orderEligibilitiesMockEligibleToInvoluntaryRefundUsingMultipleVoucherWithCCEligible,
  orderEligibilitiesMockEligibleToRefundUsingMultipleVoucherWithCCEligible,
  orderMockEligibleToRefundUsingMultipleVouchersAndCC,
} from '../../../mock/data/index';

/**
 * Mocks for refundable order using multiple vouchers.
 */
export const eligibleToRefundUsingMultipleVouchersWithCCMock: MockMap = {
  retrieveOrder: [createMockData(orderMockEligibleToRefundUsingMultipleVouchersAndCC)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleToRefundUsingMultipleVoucherWithCCEligible)],
  cancelAndRefundOrder: [createMockData(orderCancelAndRefundUsingMultipleVoucherWithCC)]
};

/**
 * Mocks for involuntary refundable order using multiple vouchers.
 */
export const eligibleToInvoluntaryRefundUsingMultipleVouchersWithCCMock: MockMap = {
  retrieveOrder: [createMockData(orderMockEligibleToRefundUsingMultipleVouchersAndCC)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleToInvoluntaryRefundUsingMultipleVoucherWithCCEligible)],
  cancelAndRefundOrder: [createMockData(orderCancelAndRefundUsingMultipleVoucherWithCC)]
};
